<template>
	<v-col
		v-bind="$attrs"
		v-on="$listeners"
		:cols="cols"
		:sm="sm">
		<slot />
	</v-col>
</template>

<script>
export default {
	name: 'KCol',
	inheritAttrs: false,
	props: {
		cols: {
			type: [Boolean, String, Number],
			default: undefined,
		},
		sm: {
			type: [Boolean, String, Number],
			default: undefined,
		},
	},
};
</script>